var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "open-api"
  }, [_c('div', {
    staticClass: "bg-white rounded-md p-6 max-w-3xl mx-auto"
  }, [_vm.isStatusLoading ? _c('div', {
    staticClass: "text-sm text-neutral-500 py-8"
  }, [_vm._v(" Memuat status Open API... ")]) : _vm.isActiveApi === false ? _c('div', {
    staticClass: "border border-neutral-200 rounded-lg p-5"
  }, [_c('p', {
    staticClass: "text-base font-bold mb-2"
  }, [_vm._v("Open API belum aktif")]), _c('p', {
    staticClass: "text-sm text-neutral-600 mb-4"
  }, [_vm._v(" Untuk mengaktifkan Open API, silakan hubungi admin melalui WhatsApp. ")]), _c('a', {
    staticClass: "inline-flex items-center justify-center text-sm font-medium rounded border border-primary-400 text-primary-400 px-4 py-2 hover:border-primary-700 hover:text-primary-700 transition-all",
    attrs: {
      "href": _vm.waLink,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(" Hubungi Admin via WhatsApp ")])]) : _vm.isActiveApi === true ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-1 gap-6 mb-8"
  }, [_c('div', {
    staticClass: "border border-neutral-200 rounded-lg p-4"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col items-center mdmax:items-start justify-between mdmax:gap-3 mb-3"
  }, [_c('p', {
    staticClass: "text-base font-bold text-neutral-900"
  }, [_vm._v("API Key")]), _c('div', {
    staticClass: "flex gap-2 flex-wrap mdmax:w-full"
  }, [_c('Button', {
    staticClass: "mdmax:flex-1",
    attrs: {
      "buttonText": _vm.apiKeyVisible ? 'Hide' : 'Show',
      "type": "secondary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.toggleApiKey();
      }
    }
  }), _c('Button', {
    staticClass: "mdmax:flex-1",
    attrs: {
      "buttonText": "Copy",
      "type": "secondary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.copyApiKey();
      }
    }
  }), _c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": "Regenerate",
      "type": "primary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.regenerateApiKey();
      }
    }
  })], 1)]), _c('TextField', {
    staticClass: "text-black",
    attrs: {
      "value": _vm.apiKeyDisplay,
      "readonly": ""
    }
  })], 1), _c('div', {
    staticClass: "border border-neutral-200 rounded-lg p-4"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col items-center mdmax:items-start justify-between mdmax:gap-3 mb-3"
  }, [_c('p', {
    staticClass: "text-base font-bold text-neutral-900"
  }, [_vm._v("Secret Key")]), _c('div', {
    staticClass: "flex gap-2 flex-wrap mdmax:w-full"
  }, [_c('Button', {
    staticClass: "mdmax:flex-1",
    attrs: {
      "buttonText": _vm.secretKeyVisible ? 'Hide' : 'Show',
      "type": "secondary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.toggleSecretKey();
      }
    }
  }), _c('Button', {
    staticClass: "mdmax:flex-1",
    attrs: {
      "buttonText": "Copy",
      "type": "secondary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.copySecretKey();
      }
    }
  }), _c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": "Regenerate",
      "type": "primary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.regenerateSecretKey();
      }
    }
  })], 1)]), _c('TextField', {
    staticClass: "text-black",
    attrs: {
      "value": _vm.secretKeyDisplay,
      "readonly": ""
    }
  })], 1)]), _c('div', {
    staticClass: "border border-neutral-200 rounded-lg p-4 mb-6"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col items-center mdmax:items-start justify-between mdmax:gap-3 mb-3"
  }, [_c('p', {
    staticClass: "text-base font-bold"
  }, [_vm._v("Webhook URL")]), _c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": _vm.webhookEditable ? 'Cancel' : 'Edit',
      "type": "secondary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.toggleWebhookEdit();
      }
    }
  })], 1), _c('TextField', {
    attrs: {
      "disabled": !_vm.webhookEditable,
      "placeholder": "https://example.com/webhook"
    },
    model: {
      value: _vm.webhookUrl,
      callback: function callback($$v) {
        _vm.webhookUrl = $$v;
      },
      expression: "webhookUrl"
    }
  })], 1), _c('a', {
    staticClass: "text-primary-400 text-sm font-medium hover:text-primary-700",
    attrs: {
      "href": _vm.docsUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(" Lihat dokumentasi Open API ")]), _c('div', {
    staticClass: "flex justify-end mt-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Update",
      "type": "primary",
      "disabled": _vm.updateLoading,
      "isLoading": _vm.updateLoading
    },
    on: {
      "action": function action($event) {
        return _vm.updateOpenApi();
      }
    }
  })], 1)]) : _c('div', {
    staticClass: "border border-neutral-200 rounded-lg p-5"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-600 mb-4"
  }, [_vm._v(" Gagal memuat status Open API. ")]), _c('Button', {
    attrs: {
      "buttonText": "Coba lagi",
      "type": "primary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.fetchApiStatus();
      }
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }